export default __webpack_public_path__ + "static/media/pos-pro-20.e2caf573.jpg";